import Enumerator from './Enumerator';

export const certificatesOfTitle = [
  'none',
  'community_title',
  'strata_title',
  'stratum_title',
  'company_title',
  'crown_land',
  'crown_lease',
  'freehold',
  'group_titles_plan',
  'leasehold',
  'moiety_title',
  'purple_title',
  'other_title'
];

export class CertificateOfTitle extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'community_title';
        break;
      case '2':
        correctOption = 'strata_title';
        break;
      case '3':
        correctOption = 'stratum_title';
        break;
      case '4':
        correctOption = 'company_title';
        break;
      case '5':
        correctOption = 'crown_land';
        break;
      case '6':
        correctOption = 'crown_lease';
        break;
      case '7':
        correctOption = 'freehold';
        break;
      case '8':
        correctOption = 'group_titles_plan';
        break;
      case '9':
        correctOption = 'leasehold';
        break;
      case '10':
        correctOption = 'moiety_title';
        break;
      case '11':
        correctOption = 'purple_title';
        break;
      case '12':
        correctOption = 'other_title';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

CertificateOfTitle.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  community_title: {
    get title() {
      return 'Community title';
    }
  },
  strata_title: {
    get title() {
      return 'Strata title';
    }
  },
  stratum_title: {
    get title() {
      return 'Stratum title';
    }
  },
  company_title: {
    get title() {
      return 'Company title';
    }
  },
  crown_land: {
    get title() {
      return 'Crown land';
    }
  },
  crown_lease: {
    get title() {
      return 'Crown lease';
    }
  },
  freehold: {
    get title() {
      return 'Freehold';
    }
  },
  group_titles_plan: {
    get title() {
      return 'Group titles plan';
    }
  },
  leasehold: {
    get title() {
      return 'Leasehold';
    }
  },
  moiety_title: {
    get title() {
      return 'Moiety title';
    }
  },
  purple_title: {
    get title() {
      return 'Purple title';
    }
  },
  other_title: {
    get title() {
      return 'Other title';
    }
  }
});

export default {
  certificatesOfTitle,
  CertificateOfTitle
};
